import { connect } from 'react-redux'
import { changeForgottenPassword, setDisabled, setError } from './reducer'

const mapStateToProps = (state) => {
    return {
        isAuth: state?.services?.auth?.isAuthorized,
        error: state?.pages?.changeForgottenPassword?.error,
        success: state?.pages?.changeForgottenPassword?.success,
        disabled: state?.pages?.changeForgottenPassword?.disabled,
        loading: state?.pages?.changeForgottenPassword?.loading,
    }
}

const hocChangeForgottenPassword = (InnerComponent) =>
    connect(mapStateToProps, { changeForgottenPassword, setError, setDisabled })(InnerComponent)

export default hocChangeForgottenPassword
